<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-Loading="isLoadingPage">
        <div slot="body">
          <bita-form ref="form">
              <div slot="body">
                  <div class="row">
                    <bita-datepicker
                        ref="fromdate"
                        type="date"
                        id="fromDate"
                        validation-container-class="col-3"
                        name="from-date"
                        label="از تاریخ"
                        inputClass="form-control"
                        v-model="searchData.from"
                    />
                    <bita-datepicker
                        ref="todate"
                        type="date"
                        id="toDate"
                        validation-container-class="col-3"
                        name="to-date"
                        label="تا تاریخ"
                        inputClass="form-control"
                        v-model="searchData.to"
                    />
                    <bita-select
                      ref="userSelect"
                      name="user"
                      label="انتخاب کاربر"
                      rule="required"
                      validation-container-class="col-3"
                      input-class="form-control"
                      :data-source="users"
                      data-text-field="full_name"
                      data-value-field="id"
                      v-model="searchData.user"
                    />
                    <bita-select
                      ref="stateSelect"
                      name="state"
                      label="نوع تراکنش"
                      rule="required"
                      validation-container-class="col-3"
                      input-class="form-control"
                      :data-source="state"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="searchData.state_id"
                    />
                  </div>
                  <bita-bootbutton
                    type="primary"
                    title="نمایش گزارش مالی"
                    btn-width="150px"
                    @click.native="handleSearch"
                  />
                  <!-- <bita-bootbutton
                    type="success"
                    title="refresh filter"
                    icon="fa fa-search"
                    btn-width="150px"
                    class="ml-2 mr-1"
                    @click.native="refreshFilter"
                  /> -->
              </div>
          </bita-form>
          <hr />
          <bita-formgroup v-show="userInfo" title="اطلاعات تکمیلی کاربر" class="row">
            <label-value label="نام" :value="userInfo.name" />
            <label-value label="نام خانوادگی" :value="userInfo.family" />
            <label-value label="کد ملی" :value="userInfo.national_code" />
            <label-value label="نوع کاربر" :value="userInfo.type" />
            <label-value label= "میزان شارژ کیف پول" :value="this.$thousandSeprator(userInfo.balance)" />
            <label-value label="موجودی قابل شمارش" :value="this.$thousandSeprator(userInfo.countable_balance)" />
            <label-value class="col-4" label="آخرین تاریخ به روز رسانی صحت سنجی" :value="userInfo.countable_balance_updated_at ? this.$getJalaliDateTime(userInfo.countable_balance_updated_at) : '---'" />
            <label-value class="col-4" label="اخرین مبلغ تصویه حساب" :value="userCheckouted.amount ? this.$thousandSeprator(userCheckouted.amount) : '---'" />
            <label-value class="col-4" label="اخرین تاریخ تصویه حساب" :value="userCheckouted.payment_at ? this.$getJalaliDate(userInfo.payment_at) : '---'" />
          </bita-formgroup>
          <bita-bootbutton
            v-if="userInfo"
            type="success"
            title="بررسی موجودی قابل شمارش"
            icon="fa fa-search"
            btn-width="250px"
            class="ml-2"
            @click.native="checkWalletCountableBalance"
          />
          <!-- <bita-bootbutton
            v-if="calculateCountableBalance"
            type="danger"
            title="نمایش جزئیات خطا"
            icon="fa fa-search"
            btn-width="250px"
            class="ml-2"
            @click.native="showCountableBalanceError"
          /> -->
          <!-- <bita-bootbutton
            v-if="userCheckouted"
            type="success"
            title="جزئیات تسویه حساب"
            icon="fa fa-search"
            btn-width="250px"
            class="ml-2"
            @click.native="showCheckoutedReport"
          /> -->
          <hr />
          <bita-grid
              v-if="showWalletReport"
              ref="grid"
              :is-loading="isLoadingGrid"
              :columns="gridColumns"
              :read-data="readData"
              :on-data-binding="onDataBinding"
              :hasRow="false"
              :resizable="true"
              :grid-server-side="false"
              :batch="true"
              :has-row-number="false"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
import LabelValue from "./LabelValue";
import ViewCheckouted from "./Checkouted";
export default {
  components: {LabelValue, ViewCheckouted},
  data() {
      return {
          breadCrumbs: [
              {title: "صفحه اصلی", link: "/"},
              {title: "گزارش مالی", link: "/wallet-report-management", active: true},
          ],
          userType: [
            {name: "صاحب بار", type: "owners"},
            {name: "باربری", type: "carriers"},
          ],
          users: {},
          state: {},
          searchData: {},
          isLoadingPage: false,
          isLoadingGrid: false,
          isLoadingModal: false,
          report: {},
          userInfo: {},
          userCheckouted: {},
          userAllCheckouted: {},
          userInfoState: false,
          total_amount: '',
          calculateCountableBalance: false,
          colWidth: "col-2",
          showWalletReport: true,
      }
  },
  computed: {
    gridColumns(){
      return [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "tracking_code", title: "کد پیگیری", template: (e) => (e.tracking_code ? e.tracking_code : "-")},
        {
          field: "amount",
          title: this.$currencyLabel('مبلغ'),
          footerTemplate: (e) => (e ? ` جمع کل  ${this.$thousandSeprator(this.total_amount)}` : ''),
          template: (e) => {
            if (e.payment_state)
              return e.amount ? `<i class="fas fa-sort-up"></i> ${this.$thousandSeprator(e.amount)}` : " - ";
              return e.amount ? `<i class="fas fa-sort-down"></i> ${this.$thousandSeprator(e.amount)}` : " - ";
          }
        },
        { field: "type_name", title: "نوع تراکنش", template: (e) => (e.type_name ? e.type_name : "-")},
        { field: "created_at", title: "زمان تراکنش", template: (e) => (e.created_at ? this.$getJalaliDateTime(e.created_at) : '-')},
      ]
    }
  },
  mounted(){
    Promise.all([
      this.getUser(),
      this.getState(),
    ]).then((res) => {
      this.users = res[0].data;
      this.state = res[1].data;
    });
  },
  methods: {
    getUser() {
      return this.$persistClient("get", "users");
    },
    getState() {
      return this.$persistClient("get", "states?type=wallet_report")
    },
    handleSearch(e) {
      this.loadData();
    },
    readData(e) {
      let url = this.$makeQueryString("reports/wr2", this.searchData, "?");
      this.$persistClient("get", url)
      .then((res) => {
        this.total_amount = res.data.data.total_amount;
        e.success(res.data.data.data);
        this.userInfo = res.data.data.user ? res.data.data.user[0] : false;
        this.userCheckouted = res.data.data.user_checkouted ? res.data.data.user_checkouted : false;
      })
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    gridCommands() {
      return [
      {
        text: "view",
        click: this.view,
        template: this.gridButtons.view,
      }];
    },
    view() {

    },
    onDataBinding: function(ev) {
      var vm = this;
      setTimeout(() => {
        var grid = $("#grid").data("kendoGrid");
        var items = ev.items;
        items.each(function(item) {
          var dataItem = item;
          var selector = $(`.k-master-row[data-uid=${item.uid}]`)
          if (!dataItem.payment_state && !vm.searchData.state_id) {
            selector.css("color", `#c0392b`);
          }
          if (dataItem.payment_state && !vm.searchData.state_id){
            selector.css("color", `#1d8348`);
          }
        });
      }, 1000);
      this.record =
        (this.gpage - 1) * this.$refs.grid.$refs.datasource.pageSize;
      var grid = this.$refs.grid.$refs.grid.kendoWidget();
      // this.report.review == 2 ? grid.hideColumn(10) : "";
    },
    refreshFilter() {
      let dropDowns = [
        "fromDate",
        "toDate",
        "userSelect",
        "stateSelect",
      ];
      this.$refs["userSelect"].emptyKendo();
      this.$refs["stateSelect"].emptyKendo();
      this.$refs["todate"].emptyKendo();
      this.$refs["fromdate"].emptyKendo();
      this.searchData = {};
    },
    checkWalletCountableBalance() {
      this.$persistClient("get", `wallets/calculate-countable-balance/${this.userInfo.id}`)
      .then((res) => {
        this.calculateCountableBalance = res.data.status == true ? false : true;
        this.loadData();
      });
    },
    showCheckoutedReport() {
       this.$persistClient("get", `users/${this.userInfo.id}/gateway-transaction`)
       .then((res) => {
         this.userAllCheckouted = res.data;
         this.showWalletReport = false;
       })
    }, 
  },
}
</script>